import { render } from "./CuentaList.vue?vue&type=template&id=9b32f600"
import script from "./CuentaList.vue?vue&type=script&lang=js"
export * from "./CuentaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__